import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const rootEl = document.getElementById("root");

if (rootEl.hasChildNodes()) {
  // Pre-rendered HTML exists — hydrate to attach event listeners
  ReactDOM.hydrateRoot(
    rootEl,
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>,
  );
} else {
  // Normal client-side render
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>,
  );
}
